import { StoreLocator } from '@fhs-legacy/frontend/src/pages/store-locator';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default StoreLocator;
